import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/diet-settings/all/',
    redirectTo: '/diet-settings/all/sex',
  },
];

export default redirects;
